import store from "redux/store";
import { fetchLensEditorLenses } from "redux/slices/lensEditor";
import { LoaderFunction, redirect } from "react-router-typesafe";
import { getSession } from "redux/slices/session";
import { isSupport } from "helpers/userHelpers";

async function isSupportCheck(): Promise<boolean> {
  return await store
    .dispatch(getSession())
    .unwrap()
    .then((r) => isSupport(r.permissions))
    .catch((e) => {
      console.error(e);
      return false;
    });
}

export const lensEditorLensesLoader = (async () => {
  const isSupport = await isSupportCheck();

  if (!isSupport) {
    return redirect("/");
  }

  return store.dispatch(fetchLensEditorLenses()).unwrap();
}) satisfies LoaderFunction;

export const shouldRevalidateLenses = () => {
  return false;
};
